<script setup lang="ts">
import { type Color } from '@global-types/colors';
import { type Subset } from '@global-types/utilities';

type DividerColor = Subset<Color, 'gray' | 'black-lighter'>;

withDefaults(defineProps<{ color?: DividerColor}>(), {
  color: 'gray',
});
</script>

<template>
  <hr
    class="divider"
    :class="`divider--color-${color}`"
  >
</template>
